Auth = require 'db/auth'
Keys = require 'data/keys'
Keyboard = require 'lib/keyboard'
template = require 'views/templates/logged_in_public_board_banner'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
WarningBannerView = require 'views/header/warning-banner-view'

module.exports = class LoggedInPublicBoardBannerView extends WarningBannerView
  className: Util.extendParentClassName('logged-in-public-board-banner')

  initialize: ->
    super

    @isHidden = false
    @listenTo @model, 'change', @frameDebounce @render

  events:
    'keydown': 'keydownEvent'
    'click .js-close-banner': 'dismiss'
    'click .js-learn-more': 'trackHelp'

  dismissalKey: -> "logged-in-public-board-#{@model.get('id')}"

  dismiss: ->
    @isHidden = true
    Auth.me()?.dismissAd(@dismissalKey())
    @render()
    trackUe('public board', 'dismisses', 'reminder banner', '', '', 'by clicking close icon', { boardid: @model.get('id') })

  isDismissed: ->
    Auth.me()?.isAdDismissed(@dismissalKey())

  trackHelp: ->
    trackUe('public board', 'opens', 'help', '', '', 'by clicking link in reminder banner', { boardid: @model.get('id') })

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)

    if key == Keys.Enter
      if @$(e.target).hasClass('js-learn-more')
        @trackHelp()

      @$('.js-learn-more')
      return

  render: ->
    isVisible = !@isHidden && !@isDismissed() && @model?.isPublic() && !@model?.get('closed')

    if isVisible
      trackUe('public board', 'displays', 'reminder banner', '', '', 'by viewing board', { boardid: @model.get('id') })

    @$el.toggleClass('hide', !isVisible)
    @$el.html template({ isAdmin: @model?.owned(), isVisible })

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/logged-in-public-board-banner-view.coffee